import { IRootState } from '../../../store'

export const getIsGlobalDataLoadingSelector = (state: IRootState): boolean => state.globalData.isGlobalDataLoading
